import containerQueries from '@tailwindcss/container-queries';
import type { Config } from 'tailwindcss';

const b2bGlobalStyles = {
    boxShadow: {
        DEFAULT: '0px 0px 15px 0px rgba(0, 0, 0, 0.1)',
        bottom: '0px 15px 10px -15px rgba(0,0,0,0.2)',
        drop: '5px 5px 0px 0px rgba(0, 0, 0, 1)',
        lg: '1px 1px 10px 0 rgba(20, 37, 66, 0.3)',
        md: '0px 0px 15px 0px rgba(0, 0, 0, 0.2)',
        none: 'none',
        outline: 'inset currentColor 0 0 0 1px', // box-shadow instead of border => no padding/margin issues
        top: '0 -5px 15px -5px rgba(0,0,0,0.2)',
    },
    colors: {
        black: 'var(--color-black)',
        blue: {
            50: 'var(--color-blue-50)',
            100: 'var(--color-blue-100)',
            200: 'var(--color-blue-200)',
            300: 'var(--color-blue-300)',
            400: 'var(--color-blue-400)',
            500: 'var(--color-blue-500)',
            600: 'var(--color-blue-600)',
            700: 'var(--color-blue-700)',
            800: 'var(--color-blue-800)',
            900: 'var(--color-blue-900)',
        },
        gray: {
            50: 'var(--color-gray-50)',
            100: 'var(--color-gray-100)',
            200: 'var(--color-gray-200)',
            300: 'var(--color-gray-300)',
            400: 'var(--color-gray-400)',
            500: 'var(--color-gray-500)',
            600: 'var(--color-gray-600)',
            700: 'var(--color-gray-700)',
            800: 'var(--color-gray-800)',
            900: 'var(--color-gray-900)',
        },
        green: {
            50: 'var(--color-green-50)',
            100: 'var(--color-green-100)',
            200: 'var(--color-green-200)',
            300: 'var(--color-green-300)',
            400: 'var(--color-green-400)',
            500: 'var(--color-green-500)',
            600: 'var(--color-green-600)',
            700: 'var(--color-green-700)',
            800: 'var(--color-green-800)',
            900: 'var(--color-green-900)',
        },
        purple: {
            50: 'var(--color-purple-50)',
            100: 'var(--color-purple-100)',
            200: 'var(--color-purple-200)',
            300: 'var(--color-purple-300)',
            400: 'var(--color-purple-400)',
            500: 'var(--color-purple-500)',
            600: 'var(--color-purple-600)',
            700: 'var(--color-purple-700)',
            800: 'var(--color-purple-800)',
            900: 'var(--color-purple-900)',
        },
        red: {
            50: 'var(--color-red-50)',
            100: 'var(--color-red-100)',
            200: 'var(--color-red-200)',
            300: 'var(--color-red-300)',
            400: 'var(--color-red-400)',
            500: 'var(--color-red-500)',
            600: 'var(--color-red-600)',
            700: 'var(--color-red-700)',
            800: 'var(--color-red-800)',
            900: 'var(--color-red-900)',
        },
        transparent: 'transparent',
        white: 'var(--color-white)',
        yellow: {
            50: 'var(--color-yellow-50)',
            100: 'var(--color-yellow-100)',
            200: 'var(--color-yellow-200)',
            300: 'var(--color-yellow-300)',
            400: 'var(--color-yellow-400)',
            500: 'var(--color-yellow-500)',
            600: 'var(--color-yellow-600)',
            700: 'var(--color-yellow-700)',
            800: 'var(--color-yellow-800)',
            900: 'var(--color-yellow-900)',
        },
    },
    extend: {
        animation: {
            loading: 'loading 1s infinite ease-out',
        },
        colors: {
            'gray-900-alpha':
                'rgb(var(--color-gray-900-alpha) / <alpha-value>)',
        },
        keyframes: {
            loading: {
                '0%, 100%': {
                    opacity: '0.25',
                },
                '20%': {
                    opacity: '1',
                },
            },
        },
        spacing: {
            content: '1600px',
            dynamic: 'var(--space-dynamic)',
            'nav-collapsed': '80px',
            'nav-extended': '352px',
            'nav-mobile': '60px'
        },
    },
    fontFamily: {
        sans: [
            'Routine K',
            'Routine K fallback',
            'Arial',
            'sans-serif'
        ],
    },
    outlineColor: {
        blue: {
            600: '#569CE8',
            900: '#012352',
        },
        current: 'currentColor',
        gray: {
            900: '#17191C',
        },
        yellow: {
            600: '#CA7137',
        },
    },
};
export default <Partial<Config>>{
    content: ['./packages/**/*.{vue,ts}', '!./packages/**/node_modules/*'],
    corePlugins: {
        backgroundColor: true,
        borderColor: true,
        borderRadius: true,
        display: true,
        flex: true,
        flexGrow: true,
        flexShrink: true,
        fontWeight: true,
        gap: true,
        gridTemplateColumns: true,
        margin: true,
        padding: true,
        preflight: true,
        textColor: true,
        textTransform: true,
        verticalAlign: true,
        width: true,
    },
    plugins: [containerQueries],
    theme: {
        ...b2bGlobalStyles,
    },
};
